import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extracts a human-readable message from an API error.
 *
 * DRF APIException and manually thrown ValidationError errors produce:
 * { detail: "message" }. Serializer validation errors produce an array under
 * either non_field_errors or a field name.
 */
export function parseApiError(
  error: unknown,
  fallback = 'An unexpected error occurred.',
): string {
  if (error instanceof HttpErrorResponse) {
    const body = error.error;
    if (body && typeof body === 'object') {
      if (typeof body.detail === 'string') return body.detail;

      const firstValue = Object.values(body)[0];
      if (typeof firstValue === 'string') return firstValue;
      if (Array.isArray(firstValue) && typeof firstValue[0] === 'string') {
        return firstValue[0];
      }
    }

    return error.message;
  }

  if (error instanceof Error) return error.message;

  return fallback;
}
